export enum RejectSubType {
  CANCEL_REJECT,
  NONE,
}

export namespace RejectSubType {
  let elements = [RejectSubType.CANCEL_REJECT, RejectSubType.NONE];
  let alias = "com.bcdfx.api.event.RejectSubType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
